var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "-12.5 -12.5 150.00 150.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#c9c9c9",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.25
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 97,
    height: 97,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35,
    width: 82,
    height: 55,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35,
    width: 82,
    height: 55,
    rx: 2,
    stroke: "#c9c9c9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3093 68.8661C63.5578 69.517 62.4422 69.517 61.6907 68.8661L29.8161 41.2619C28.4162 40.0496 29.2736 37.75 31.1254 37.75L94.8747 37.75C96.7264 37.75 97.5838 40.0496 96.1839 41.2619L64.3093 68.8661Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 47L63.5 70L91 47",
    stroke: "#c9c9c9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 69,
    y1: 87.5,
    x2: 63,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#c9c9c9",
    stopOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.978f5a3a32a28a5df6f7c44085b8e03f.svg";
export { ForwardRef as ReactComponent };